import { Option } from '../../option.js';
import { IStructuralTransformer } from './StructuralTransformer.js';
import { SourcedValueOptions } from '../../option.js';

export class FlatStructuralTransformer<T = {}> implements IStructuralTransformer<Option<T>[]> {
  constructor(private preserveDuplicates = false) {
  }
  transform(sourcedValueOptions: SourcedValueOptions): Option<T>[] {
    const q = sourcedValueOptions.slice();
    let collection: ICollection<Option<T>> = this.preserveDuplicates
      ? new ListCollection<Option<T>>()
      : new SetCollection<Option<T>>(o => o._id);
    while (q.length > 0) {
      const next = q.shift()!;
      if (next instanceof Option) {
        collection.add(next as Option<T>);
      } else {
        q.unshift(...next.children);
      }
    }
    return collection.values();
  }
}

interface ICollection<T> {
  add(item: T);

  values(): T[]
}

export class ListCollection<T> implements ICollection<T> {
  private items: T[] = [];

  add(item: T) {
    this.items.push(item);
  }

  values(): T[] {
    return this.items;
  }
}

export class SetCollection<T> implements ICollection<T> {
  private items: Map<string, T> = new Map<string, T>();

  constructor(private keySelector: (item: T) => string) {
  }

  add(item: T) {
    this.items.set(this.keySelector(item), item);
  }

  values(): T[] {
    return Array.from(this.items.values());
  }
}
